import xray from "../assets/icons/xray/xray.svg";
import lighting from "../assets/icons/lightning/lightning.svg";
import userOutline from "../assets/icons/userOutline/user.svg";
import check from "../assets/icons/check/icons.svg";
import clock from "../assets/icons/clock/icons.svg";
import arrowDown from "../assets/icons/arrows/ArrowDownIcon.svg";

export const assetIcons = {
  xray,
  lighting,
  userOutline,
  check,
  clock,
  arrowDown,
};
